import { StoreURLAction } from '@/store/store-url.action';

export const STORE_CONFIG  = {
  modules: {
    url: {
      actions: {
        ['store']: new StoreURLAction().actions['store']
      }
    }
  }
};
